// Omera Exports — i18n dictionaries (English + Arabic)
// Each section's strings live under a namespace.

export const en = {
  meta: { dir: "ltr", code: "EN", label: "English", short: "EN" },

  nav: {
    about: "About",
    products: "Collection",
    rods: "Export",
    why: "Craft",
    experience: "Experience",
    contact: "Contact",
    cta: "Request Catalogue",
    catalogue: "Catalogue",
  },

  hero: {
    overline: "Volume I — Brass Edition",
    side: "Est · Mumbai · India",
    title_a: "Global Exporters of",
    title_b: "Premium Brass ",
    title_c: "Hardware",
    sub:
      "India's leading brass hardware manufacturer and export house for solid brass architectural hardware. We manufacture and supply premium hinges, bolts, and door fittings to international dealers, builders, and specifiers worldwide.",
    explore: "Explore Products",
    contact: "Contact Us",
    scroll: "Scroll",
    stats: [
      { v: "40+", l: "Countries Exported To" },
      { v: "350+", l: "Global Clients" },
      { v: "100%", l: "Export Quality Brass" },
      { v: "OEM", l: "Custom Manufacturing" },
    ],
  },

  marquee: [
    "Global Brass Exporters",
    "Container-Load Supply",
    "FOB & CIF Shipping",
    "Mumbai · India",
    "Export Grade Hardware",
    "Custom OEM Manufacturing",
    "Serving 40+ Countries",
    "International Standards",
  ],

  about: {
    overline: "Global Export Division",
    title_a: "India's premier",
    title_b: " brass export house",
    title_c: "serving global markets.",
    body:
      "Omera Exports is the dedicated international trade division of Jayguru Brass. As a direct OEM brass fittings manufacturer in India, we specialize in manufacturing and exporting high-volume, premium solid-brass hinges, tower bolts, and architectural hardware to foreign clients. Our production is strictly calibrated to meet international architectural-grade standards.",
    legacy_overline: "A Family Legacy",
    legacy_brand: "Jayguru Brass",
    atelier: "Export House",
    city_a: "Mumbai",
    city_b: "India",
    audiences: ["International Dealers", "Global Distributors", "Overseas Builders", "OEM Clients"],
    pillars: [
      { v: "Quality", l: "Export Grade" },
      { v: "Logistics", l: "Logistics Safe & Secure Packaging" },
      { v: "Trust", l: "Reliable Business Partner" },
    ],
  },

  products: {
    overline: "The Export Collection · 2026",
    title_a: "Exporting ",
    title_b: "brass excellence",
    title_c: "worldwide.",
    body:
      "Our primary export catalog — featuring export-grade brass rods and hand-finished architectural hardware manufactured for international markets. All products are securely packed for global transit with complete documentation.",
    series: "Series",
    cta: "Request the full export catalogue",
    foot:
      "Looking for a specific finish, dimension or custom OEM manufacturing? Our global trade desk responds within 24 hours.",
    items: [
      {
        title: "Fancy Door Handles",
        tagline: "Elegant designs · premium feel",
        desc: "Exquisite fancy door handles crafted for luxury interiors and statement entrances.",
      },
      {
        title: "Brass Hinges",
        tagline: "Cast solid-brass · architectural pivot",
        desc: "Heritage-quality hinges machined to micron tolerances, heavily exported to European and US markets.",
      },
      {
        title: "Cabinet Knobs",
        tagline: "Precision detailing · perfect scale",
        desc: "Solid brass knobs machined to perfection, adding a touch of understated luxury to premium cabinetry.",
      },
      {
        title: "Pull Handles",
        tagline: "Statement pieces · robust grip",
        desc: "Large scale pull handles designed to create a bold entrance for luxury commercial and residential doors.",
      },
      {
        title: "Brass Rods",
        tagline: "Round · Hex · Square · Custom profiles",
        desc: "Export-grade brass rods drawn to precise tolerances for industrial, architectural and engineering use globally.",
      },
      {
        title: "Tower Bolts",
        tagline: "Precision-fit · concealed engineering",
        desc: "Heavyweight bolts designed for demanding international installations and superior security.",
      },
    ],
  },

  rods: {
    overline: "Export Division · Brass Rods",
    title_a: "Precision brass rods,",
    title_b: "built for",
    title_c: "global specification.",
    body:
      "Extruded and drawn solid-brass rods in round, hex, square and custom profiles — supplied to architectural, engineering and OEM projects across UAE, GCC, Europe and the United States. Mill Test Certificate shipped with every consignment.",
    badges: [
      "40+ countries",
      "FOB · CIF · CFR",
      "Export packaging",
      "Mill Test Cert.",
    ],
    destinations: [
      "UAE", "Saudi Arabia", "Qatar", "Oman", "Kuwait", "Bahrain",
      "USA", "UK", "Germany", "Italy", "Australia", "Singapore",
    ],
    types: [
      { title: "Round Brass Rods", dims: "Ø 2 mm — 150 mm", grades: "CZ121 · C36000 · IS319" },
      { title: "Hex Brass Rods", dims: "AF 3 mm — 80 mm", grades: "CZ121 · C38500 · H59" },
      { title: "Square Brass Rods", dims: "3 mm — 100 mm sq.", grades: "CZ121 · C36000" },
      { title: "Custom Brass Profiles", dims: "Drawing-based", grades: "Per specification" },
    ],
    size: "Size",
    grades: "Grades",
    inquire: "Request Specification",
    table_overline: "Technical Data",
    table_title: "Brass Rod — Master Specification",
    table_spec: "Spec · OMR-RODS-2026",
    rows: [
      ["Material Grade", "CZ121 · C36000 · C38500 · IS319 · DIN equivalents"],
      ["Diameter / Size", "2 mm – 150 mm (Round) · Custom for Hex / Square / Profiles"],
      ["Length", "Standard 3 m · Cut-to-length from 100 mm"],
      ["Tolerance", "DIN H9 / H11 · Custom on request"],
      ["Finish", "Bright-drawn · Polished · Pickled · Anodised"],
      ["Packaging", "Wooden crates · Plastic-wrapped bundles · Export-grade"],
      ["MOQ", "500 kg per size · Mixed containers accepted"],
      ["Lead Time", "14 – 28 days ex-Mumbai"],
      ["Incoterms", "FOB · CIF · CFR · EXW (India)"],
      ["Certification", "Mill Test Certificate · RoHS · REACH on request"],
    ],
    bulk_overline: "Bulk · Export",
    bulk_title_a: "Container-load",
    bulk_title_b: "inquiries.",
    bulk_body:
      "Share your sizes, grades, quantities and destination port — our export desk responds within one working day with pro-forma and lead time.",
    cta_quote: "Request Export Quote",
    cta_whatsapp: "WhatsApp Bulk Inquiry",
    foot_keys: ["MOQ", "Lead Time", "Port", "Payment"],
    foot_vals: ["500 kg", "14 – 28 days", "Nhava Sheva · Mundra", "TT · LC · Advance"],
  },

  why: {
    overline: "The Export Standard",
    title_a: "Why global buyers",
    title_b: "choose",
    title_c: "Omera.",
    body:
      "Six pillars that define how we manufacture, pack and export architectural hardware — from our facility in Mumbai to your international destination.",
    standard: "Standard",
    items: [
      { title: "Durable Brass Quality", desc: "Solid-brass bodies with verified composition for international dimensional stability." },
      { title: "Precision Finishing", desc: "Hand-polished, brushed and PVD-treated finishes calibrated to global architectural standards." },
      { title: "Export Packaging", desc: "Secure, sea-worthy packaging ensuring your hardware arrives safely across the globe." },
      { title: "Seamless Logistics", desc: "Expert handling of FOB and CIF shipments, customs documentation, and timely delivery." },
      { title: "Bulk Capabilities", desc: "Volume programmes tailored for international distributors and large-scale foreign projects." },
      { title: "OEM Manufacturing", desc: "Custom manufacturing strictly per client drawings and international specifications." },
    ],
  },

  experience: {
    overline: "Global Reach",
    title_a: "Hardware ",
    title_b: "exported",
    title_c: " across the",
    title_d: "world.",
    body:
      "A visual journal of the premium hardware we export globally — equipping luxury residences, hotels, and commercial spaces internationally.",
    captions: [
      "Export Grade · Tower Bolt",
      "Global · Premium Hinges",
      "Detail · Precision Hand-finished",
    ],
    quote: "International hardware supply requires immense trust and precision. We deliver both.",
    quote_by: "Omera Exports · Global Trade Desk",
  },

  contact: {
    overline: "Global Export Desk · Mumbai",
    title_a: "Start an",
    title_b: "export inquiry.",
    body:
      "For FOB/CIF pricing, international shipping details, OEM manufacturing, or container-load orders — our export team responds within one working day.",
    whatsapp: "WhatsApp",
    phone: "Phone",
    email: "Email",
    atelier: "Export House",
    location: "Mumbai · India",
    form_overline: "Inquiry · Global Trade",
    form_title: "Request an export quotation",
    form_id: "Form · 01",
    f_name: "Full name",
    f_email: "Email",
    f_phone: "Phone (with country code)",
    f_company: "Company / Region",
    f_interest: "Interest",
    f_message: "Message",
    f_placeholder: "Tell us about your target port, quantities, or specific products...",
    submit: "Send Export Inquiry",
    submitting: "Sending...",
    consent: "By submitting, you agree to be contacted by our international trade desk.",
    interests: [
      "Brass Rods · Export",
      "Brass Hinges",
      "Tower Bolts",
      "Door Handles",
      "Architectural Hardware",
      "OEM Manufacturing",
      "Container Load / Bulk",
      "International Dealership",
    ],
    success: "Export inquiry received. Our global desk will respond within 24h.",
    error_required: "Please fill in name, email and message.",
    error_send: "Couldn't send inquiry. Please try WhatsApp or email.",
  },

  footer: {
    place: "Jayguru Brass · Mumbai",
    desc:
      "India's leading OEM manufacturer and exporter of precision-crafted brass hardware for global markets.",
    atelier_overline: "Head Office",
    atelier_addr: "Jayguru Brass\nMumbai, Maharashtra · India",
    navigate: "Navigate",
    collection: "Collection",
    follow: "Follow",
    back_to_top: "Back to top",
    rights: "© {year} Jayguru Brass · All rights reserved. Exported from Mumbai.",
    cta_overline: "Export · OEM · Wholesale",
    cta_title_a: "Supply your",
    cta_title_b: "global market.",
    cta_body:
      "From custom OEM samples to full container-loads shipped CIF to your destination port — our international desk is ready.",
    cta_whatsapp: "Chat on WhatsApp",
    cta_email: "Email Export Desk",
    legal: ["Privacy", "Terms", "Export Policy"],
    designed_in: "Manufactured & Exported from Mumbai · India",
    nav_items: [
      { id: "about", label: "About" },
      { id: "products", label: "Collection" },
      { id: "rods", label: "Brass Rods · Export" },
      { id: "why", label: "Export Standard" },
      { id: "experience", label: "Global Reach" },
      { id: "contact", label: "Contact" },
    ],
    collection_items: [
      "Brass Rods",
      "Brass Hinges",
      "Tower Bolts",
      "Door Handles",
      "Architectural Hardware",
      "OEM Services",
    ],
  },

  whatsapp: { kicker: "Export Desk", label: "WhatsApp" },

  catalogue_page: {
    title_a: "Our ",
    title_b: "Catalogue",
    subtitle: "Explore our premium collection of solid brass door handles, cabinet knobs, hinges, and architectural hardware designed for luxury interiors.",
    categories: {
      "All": "All",
      "Fancy Door Handle": "Fancy Door Handles",
      "Hinge": "Hinges",
      "Cabinet Knob": "Cabinet Knobs",
      "Pull Handle": "Pull Handles",
      "Brass Rod": "Brass Rods",
      "Tower Bolt": "Tower Bolts"
    }
  },
};

export const ar = {
  meta: { dir: "rtl", code: "AR", label: "العربية", short: "عربي" },

  catalogue_page: {
    title_a: "كتالوج ",
    title_b: "منتجاتنا",
    subtitle: "استكشف مجموعتنا الفاخرة من مقابض الأبواب ومقابض الخزائن المصنوعة من النحاس الصلب، المصممة للارتقاء بالديكورات الداخلية الفاخرة بحرفية لا مثيل لها.",
    categories: {
      "All": "الكل",
      "Fancy Door Handle": "مقابض أبواب فاخرة",
      "Hinge": "مفصلات",
      "Cabinet Knob": "مقابض خزائن",
      "Pull Handle": "مقابض سحب",
      "Brass Rod": "قضبان نحاسية",
      "Tower Bolt": "ترابيس"
    }
  },

  nav: {
    about: "عن الشركة",
    products: "المجموعة",
    rods: "التصدير",
    why: "معايير التصدير",
    experience: "الوصول العالمي",
    contact: "تواصل",
    cta: "طلب الكتالوج",
    catalogue: "الكتالوج",
  },

  hero: {
    overline: "المجلد الأول — إصدار النحاس",
    side: "تأسست · مومباي · الهند",
    title_a: "مصدرون عالميون",
    title_b: "لأجهزة النحاس",
    title_c: "الفاخرة",
    sub:
      "أبرز دار تصدير في الهند للأجهزة المعمارية النحاسية. نصنع ونورّد مفصلات وأقفال وتجهيزات أبواب فاخرة للموزعين والمقاولين في جميع أنحاء العالم.",
    explore: "استكشف المنتجات",
    contact: "تواصل معنا",
    scroll: "تمرير",
    stats: [
      { v: "+40", l: "دولة تم التصدير إليها" },
      { v: "+350", l: "عميل عالمي" },
      { v: "100%", l: "نحاس بجودة تصدير" },
      { v: "OEM", l: "تصنيع مخصص" },
    ],
  },

  marquee: [
    "مصدرو نحاس عالميون",
    "توريد بالحاويات",
    "شحن FOB و CIF",
    "مومباي · الهند",
    "أجهزة بدرجة تصدير",
    "تصنيع OEM مخصص",
    "نخدم أكثر من 40 دولة",
    "معايير دولية",
  ],

  about: {
    overline: "قسم التصدير العالمي",
    title_a: "أبرز دار",
    title_b: "لتصدير النحاس",
    title_c: "في الهند للأسواق العالمية.",
    body:
      "أوميرا إكسبورتس هي قسم التجارة الدولية المخصص لشركة جاي جورو براس. نحن متخصصون في تصنيع وتصدير المفصلات النحاسية وأقفال الأبراج والأجهزة المعمارية للعملاء الأجانب بكميات كبيرة. يتم معايرة إنتاجنا بدقة لتلبية المعايير الدولية.",
    legacy_overline: "إرث عائلي",
    legacy_brand: "جاي جورو براس",
    atelier: "دار التصدير",
    city_a: "مومباي",
    city_b: "الهند",
    audiences: ["الموزعون الدوليون", "الموزعون العالميون", "المقاولون الأجانب", "عملاء OEM"],
    pillars: [
      { v: "جودة", l: "درجة تصدير" },
      { v: "لوجستيات", l: "لوجستيات تغليف آمن وموثوق" },
      { v: "ثقة", l: "شريك أعمال موثوق" },
    ],
  },

  products: {
    overline: "مجموعة التصدير · 2026",
    title_a: "تصدير",
    title_b: "تميز النحاس",
    title_c: "لجميع أنحاء العالم.",
    body:
      "كتالوج التصدير الأساسي لدينا — يضم قضبان النحاس بدرجة التصدير والأجهزة المعمارية المشطبة يدويًا والمصنعة للأسواق الدولية. يتم تعبئة جميع المنتجات بشكل آمن للنقل العالمي مع وثائق كاملة.",
    series: "سلسلة",
    cta: "طلب كتالوج التصدير الكامل",
    foot:
      "هل تبحث عن تشطيب معين أو أبعاد أو تصنيع OEM مخصص؟ مكتب التجارة العالمي لدينا يرد خلال 24 ساعة.",
    items: [
      {
        title: "مقابض أبواب فاخرة",
        tagline: "تصميمات أنيقة · إحساس مميز",
        desc: "مقابض أبواب فاخرة ورائعة مصممة للديكورات الداخلية الفاخرة والمداخل البارزة.",
      },
      {
        title: "مفصلات نحاسية",
        tagline: "نحاس صلب مصبوب · محور معماري",
        desc: "مفصلات بجودة تراثية مصنعة بتفاوتات ميكرونية، يتم تصديرها بكثافة إلى الأسواق الأوروبية والأمريكية.",
      },
      {
        title: "مقابض خزائن",
        tagline: "تفاصيل دقيقة · مقياس مثالي",
        desc: "مقابض من النحاس الصلب مصنعة بإتقان، تضفي لمسة من الفخامة الرقيقة على الخزائن الممتازة.",
      },
      {
        title: "مقابض سحب",
        tagline: "قطع مميزة · قبضة قوية",
        desc: "مقابض سحب كبيرة الحجم مصممة لإنشاء مدخل جريء للأبواب التجارية والسكنية الفاخرة.",
      },
      {
        title: "قضبان نحاسية",
        tagline: "دائرية · سداسية · مربعة · قطاعات مخصصة",
        desc: "قضبان نحاسية بجودة تصدير مسحوبة بتفاوتات دقيقة للاستخدام الصناعي والمعماري والهندسي عالمياً.",
      },
      {
        title: "ترابيس (Tower Bolts)",
        tagline: "ملاءمة دقيقة · هندسة مخفية",
        desc: "ترابيس ثقيلة الوزن مصممة للتركيبات الدولية الصعبة والأمان الفائق.",
      },
    ],
  },

  rods: {
    overline: "قسم التصدير · القضبان النحاسية",
    title_a: "قضبان نحاسية دقيقة،",
    title_b: "مصممة وفق",
    title_c: "المواصفات العالمية.",
    body:
      "قضبان نحاس صلب مبثوقة ومسحوبة بمقاطع مستديرة وسداسية ومربعة ومخصصة — تُورَّد لمشاريع معمارية وهندسية و OEM في الإمارات ودول الخليج وأوروبا والولايات المتحدة. شهادة اختبار المصنع تُرفق مع كل شحنة.",
    badges: [
      "+40 دولة",
      "FOB · CIF · CFR",
      "تغليف للتصدير",
      "شهادة اختبار",
    ],
    destinations: [
      "الإمارات", "السعودية", "قطر", "عُمان", "الكويت", "البحرين",
      "الولايات المتحدة", "المملكة المتحدة", "ألمانيا", "إيطاليا", "أستراليا", "سنغافورة",
    ],
    types: [
      { title: "قضبان نحاسية مستديرة", dims: "Ø 2 ملم — 150 ملم", grades: "CZ121 · C36000 · IS319" },
      { title: "قضبان نحاسية سداسية", dims: "AF 3 ملم — 80 ملم", grades: "CZ121 · C38500 · H59" },
      { title: "قضبان نحاسية مربعة", dims: "3 ملم — 100 ملم مربع", grades: "CZ121 · C36000" },
      { title: "مقاطع نحاسية مخصصة", dims: "حسب الرسم", grades: "حسب المواصفات" },
    ],
    size: "المقاس",
    grades: "الدرجات",
    inquire: "طلب المواصفات",
    table_overline: "بيانات تقنية",
    table_title: "القضبان النحاسية — المواصفات الرئيسية",
    table_spec: "مواصفات · OMR-RODS-2026",
    rows: [
      ["درجة المادة", "CZ121 · C36000 · C38500 · IS319 · ما يعادل DIN"],
      ["القطر / المقاس", "2 ملم – 150 ملم (مستدير) · مخصص للسداسي / المربع / المقاطع"],
      ["الطول", "قياسي 3 م · قص حسب الطلب من 100 ملم"],
      ["التحمل", "DIN H9 / H11 · مخصص عند الطلب"],
      ["التشطيب", "مسحوب لامع · مصقول · مخلل · مؤكسد"],
      ["التغليف", "صناديق خشبية · حزم بلاستيكية · بدرجة تصدير"],
      ["الحد الأدنى", "500 كجم لكل مقاس · حاويات مختلطة مقبولة"],
      ["مدة التسليم", "14 – 28 يوماً من مومباي"],
      ["شروط التجارة", "FOB · CIF · CFR · EXW (الهند)"],
      ["الشهادات", "شهادة اختبار المصنع · RoHS · REACH عند الطلب"],
    ],
    bulk_overline: "بالجملة · تصدير",
    bulk_title_a: "استفسارات",
    bulk_title_b: "الحاويات.",
    bulk_body:
      "شارك المقاسات والدرجات والكميات وميناء الوصول — مكتب التصدير لدينا يردّ خلال يوم عمل واحد بعرض مبدئي ومدة التسليم.",
    cta_quote: "طلب عرض سعر للتصدير",
    cta_whatsapp: "استفسار جماعي عبر واتساب",
    foot_keys: ["الحد الأدنى", "مدة التسليم", "الميناء", "الدفع"],
    foot_vals: ["500 كجم", "14 – 28 يوماً", "نهافا شيفا · موندرا", "تحويل · LC · مقدّم"],
  },

  why: {
    overline: "معيار التصدير",
    title_a: "لماذا يختار المشترون",
    title_b: "العالميون",
    title_c: "أوميرا.",
    body:
      "ست ركائز تُحدد كيف نصنع ونغلف ونُصدّر الأجهزة المعمارية — من منشأتنا في مومباي إلى وجهتك الدولية.",
    standard: "معيار",
    items: [
      { title: "جودة نحاسية دائمة", desc: "أجسام نحاسية صلبة بتركيبة موثّقة لاستقرار أبعاد عالمي." },
      { title: "تشطيب دقيق", desc: "تشطيبات مصقولة يدوياً ومُفرّشاة و PVD معايرة وفق المعايير المعمارية العالمية." },
      { title: "تغليف للتصدير", desc: "تغليف آمن ومناسب للشحن البحري يضمن وصول أجهزتك بسلام إلى جميع أنحاء العالم." },
      { title: "لوجستيات سلسة", desc: "معالجة خبيرة لشحنات FOB و CIF، ووثائق الجمارك، والتسليم في الوقت المناسب." },
      { title: "قدرات الحاويات", desc: "برامج كميات مصممة للموزعين الدوليين والمشاريع الأجنبية الكبرى." },
      { title: "تصنيع OEM", desc: "تصنيع مخصص وفقًا لرسومات العميل والمواصفات الدولية بصرامة." },
    ],
  },

  experience: {
    overline: "الوصول العالمي",
    title_a: "أجهزة",
    title_b: "تُصدّر",
    title_c: "إلى جميع",
    title_d: "أنحاء العالم.",
    body:
      "مجلة بصرية للأجهزة الفاخرة التي نصدّرها عالمياً — تجهيز المساكن الفاخرة والفنادق والمساحات التجارية دولياً.",
    captions: [
      "درجة تصدير · قفل برج",
      "عالمي · مفصلات فاخرة",
      "تفصيل · تشطيب يدوي دقيق",
    ],
    quote: "توريد الأجهزة دولياً يتطلب ثقة ودقة هائلة. نحن نقدم كليهما.",
    quote_by: "أوميرا إكسبورتس · مكتب التجارة العالمي",
  },

  contact: {
    overline: "مكتب التصدير العالمي · مومباي",
    title_a: "ابدأ",
    title_b: "استفسار تصدير.",
    body:
      "لأسعار FOB/CIF ومفاوضات الشحن الدولي وتصنيع OEM أو طلبات الحاويات — فريق التصدير لدينا يرد خلال يوم عمل واحد.",
    whatsapp: "واتساب",
    phone: "هاتف",
    email: "بريد إلكتروني",
    atelier: "دار التصدير",
    location: "مومباي · الهند",
    form_overline: "استفسار · تجارة عالمية",
    form_title: "طلب عرض سعر تصدير",
    form_id: "نموذج · 01",
    f_name: "الاسم الكامل",
    f_email: "البريد الإلكتروني",
    f_phone: "الهاتف (مع رمز البلد)",
    f_company: "الشركة / المنطقة",
    f_interest: "الاهتمام",
    f_message: "الرسالة",
    f_placeholder: "أخبرنا عن الميناء المستهدف أو الكميات أو منتجات معينة...",
    submit: "إرسال استفسار تصدير",
    submitting: "جارٍ الإرسال...",
    consent: "بإرسالك هذا النموذج، أنت توافق على أن يتواصل معك مكتبنا التجاري الدولي.",
    interests: [
      "قضبان نحاسية · تصدير",
      "مفصلات نحاسية",
      "أقفال أبراج",
      "مقابض أبواب",
      "أجهزة معمارية",
      "تصنيع OEM",
      "حمولة حاوية / جملة",
      "وكالة دولية",
    ],
    success: "تم استلام استفسار التصدير. سيرد مكتبنا العالمي خلال 24 ساعة.",
    error_required: "يرجى ملء الاسم والبريد الإلكتروني والرسالة.",
    error_send: "تعذّر إرسال الاستفسار. يرجى استخدام واتساب أو البريد الإلكتروني.",
  },

  footer: {
    place: "جاي جورو براس · مومباي",
    desc: "أبرز مصدر في الهند للأجهزة النحاسية المصنوعة بدقة للأسواق العالمية.",
    atelier_overline: "المكتب الرئيسي",
    atelier_addr: "جاي جورو براس\nمومباي، ماهاراشترا · الهند",
    navigate: "تنقل",
    collection: "المجموعة",
    follow: "تابعنا",
    back_to_top: "العودة للأعلى",
    rights: "© {year} جاي جورو براس · جميع الحقوق محفوظة. مُصدّر من مومباي.",
    cta_overline: "تصدير · OEM · جملة",
    cta_title_a: "ورّد إلى",
    cta_title_b: "سوقك العالمي.",
    cta_body:
      "من عينات OEM المخصصة إلى حاويات كاملة تُشحن CIF إلى ميناء الوصول الخاص بك — مكتبنا الدولي مستعد.",
    cta_whatsapp: "تواصل عبر واتساب",
    cta_email: "بريد مكتب التصدير",
    legal: ["الخصوصية", "الشروط", "سياسة التصدير"],
    designed_in: "مُصنع ومُصدّر من مومباي · الهند",
    nav_items: [
      { id: "about", label: "عن الشركة" },
      { id: "products", label: "المجموعة" },
      { id: "rods", label: "قضبان نحاسية · تصدير" },
      { id: "why", label: "معايير التصدير" },
      { id: "experience", label: "الوصول العالمي" },
      { id: "contact", label: "تواصل" },
    ],
    collection_items: [
      "قضبان نحاسية",
      "مفصلات نحاسية",
      "أقفال أبراج",
      "مقابض أبواب",
      "أجهزة معمارية",
      "خدمات OEM",
    ],
  },

  whatsapp: { kicker: "مكتب التصدير", label: "واتساب" },
};

export const dictionaries = { en, ar };
